function getLengthCost(state, props) {
	const totalLength = state.totalLength;
	const diff = props.targetLength - totalLength;
	return diff >= 0 ? diff * diff : 1e6;
}
export { getLengthCost };

//# sourceMappingURL=index145.js.map